import { THEMES } from "../constants";
import merge from "deepmerge";

export const colors = {
  white: "#fff",
  primaryBlue: "#6fc0ff",
  offWhite: "#F6F8FC",
  gray: "#434343",
  mouseGray: "#494949",
  lightGray: "#505050",
  blueGray: "#E4E9F3",
  offBlack: "#3A424B",
  green: "#37ac3c",
  red: "#ff0000",
  lightCyan: "#E4E9F3",
  lightPurple: "#6C6DB3",
  lightBlue: "#5982a1",
  opacityWhite: "#ffffff80",
  opacityBlack: "#00000080",
};

const defaultVariant = {
  name: THEMES.DEFAULT,
  palette: {
    mode: "light",
    primary: {
      main: colors.primaryBlue,
      contrastText: colors.white,
    },
    secondary: {
      main: colors.offBlack,
      contrastText: colors.offBlack,
    },
    background: {
      default: colors.offWhite,
      paper: colors.blueGray,
      menuBackground: colors.white,
      blueCard: colors.grayBlue,
    },
    switch: {
      active: colors.green,
      inactive: colors.red,
    },
    themeSwitch: {
      checked: colors.lightBlue,
    },
    dropzone: {
      background: colors.lightBlue,
    },
    planInfo: {
      background: colors.lightCyan,
    },
    blueCard: {
      main: colors.blueGray,
    },
    authBg: {
      background: colors.opacityWhite,
    },
  },
};

const darkVariant = merge(defaultVariant, {
  name: THEMES.DARK,
  palette: {
    mode: "dark",
    background: {
      default: colors.gray,
      paper: colors.lightGray,
      menuBackground: colors.mouseGray,
    },
    text: {
      primary: colors.white,
    },
    secondary: {
      main: colors.white,
      contrastText: colors.white,
    },
    switch: {
      background: colors.lightGray,
      thumb: colors.gray,
    },
    themeSwitch: {
      thumb: colors.white,
      background: colors.gray,
    },
    planInfo: {
      background: colors.lightBlue,
    },
    blueCard: {
      main: colors.lightBlue,
    },
    authBg: {
      background: colors.opacityBlack,
    },
  },
});

const lightVariant = merge(defaultVariant, {
  name: THEMES.LIGHT,
  palette: {
    mode: "light",
    switch: {
      background: colors.lightCyan,
      thumb: colors.white,
    },
    themeSwitch: {
      thumb: colors.lightPurple,
      background: colors.lightCyan,
    },
  },
  text: {
    primary: colors.offBlack,
  },
});

const variants = [defaultVariant, darkVariant, lightVariant];

export default variants;
